module.exports = __webpack_public_path__ + "static/icons/icon-chevron-left-c0877d6f7f20e4fbe6df53b3a56f7308.svg";